import { Component, OnInit, ViewChild, AfterViewChecked, ChangeDetectorRef, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { KbwService } from '@src/app/services/kbwService.service';
import { ExamInfo, ExamBaseData } from '@src/models/examInfo.model';
import { Router } from '@angular/router';
import { MessageService } from '../../services/messageService.service';
import { Subscription } from 'node_modules/rxjs';
import { environment } from '@src/environments/environment';
import { HeaderComponent } from '../header/header.component';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import {ThemePalette} from '@angular/material/core';
import  Utils  from '../../helpers/Utils';
// import { NgSelectModule } from '@ng-select/ng-select';

@Component({
    selector: 'app-gatetype',
    templateUrl: './gatetype.component.html',
    styleUrls: ['./gatetype.component.scss'],
    providers: [KbwService, MessageService],
    standalone: false
})
export class GatetypeComponent implements OnInit, AfterViewChecked {
  constructor(
    public translate: TranslateService,
    private router: Router,
    private messageService: MessageService,
    private cdRef: ChangeDetectorRef,
    ) {
      translate.setDefaultLang('en-GB');
      translate.use('en-GB');
     }
  @ViewChild(HeaderComponent)
  color: ThemePalette = 'accent';
  mode: ProgressSpinnerMode = 'indeterminate';
  value = 50;
  isLoadnig = true;
  private bookType = '';
  private headerComp: HeaderComponent;
  // trainings: Array<ExamBaseData>;
  // selectedExam: number;
  message: string;
  subscription: Subscription;
  
  public selectedLang: number;
  public langs = [
    {id: 1, name: 'gb', desc: 'English', code: 'en-GB', order: 2},
    {id: 2, name: 'pl', desc: 'Polski', code: 'pl-PL', order: 4},
    {id: 3, name: 'de', desc: 'Deutsch', code: 'de-DE', order: 3},
    {id: 4, name: 'ru', desc: 'Русский', code: 'ru-RU', order: 5},
    {id: 5, name: 'bg', desc: 'Български', code: 'bg-BG', order: 10},
    {id: 6, name: 'cz', desc: 'Český', code: 'cs-CZ', order: 14},
    {id: 7, name: 'es', desc: 'Español', code: 'es-ES', order: 8},
    {id: 8, name: 'ee', desc: 'Eesti', code: 'et-EE', order: 12},
    {id: 9, name: 'fr', desc: 'Français', code: 'fr-FR', order: 1},
    {id: 10, name: 'hu', desc: 'Magyar', code: 'hu-HU', order: 13},
    {id: 11, name: 'it', desc: 'Italiana', code: 'it-IT', order: 9},
    {id: 12, name: 'lt', desc: 'Lietuvių', code: 'lt-LT', order: 11},
    {id: 13, name: 'pt', desc: 'Português', code: 'pt-PT', order: 7},
    {id: 14, name: 'ro', desc: 'Română', code: 'ro-RO', order: 6},
    {id: 15, name: 'si', desc: 'Slovenski', code: 'sl-SI', order: 15}
  ];
  public ways = [
    {id: 1, name: 'gateInbound', icon: 'call_made', trainingCodes:  ['15', '20', '21']},
    {id: 2, name: 'gateOutbound', icon: 'call_received', trainingCodes: ['7', '8', '9', '10', '11']},
    {id: 3, name: 'gateSales', icon: 'compare_arrows', trainingCodes: ['25', '26']}
  ];
  public gateTypes: Array<any>;

  selectedGate: number;

  setLang(langCode){
    Utils.setLang(this.translate, langCode, this.bookType);
  }


  ngAfterViewChecked(): void {
    // this.headerComp.isHiddenMenu = true;
    this.cdRef.detectChanges();
  }

  ngOnInit() {
    this.bookType = Utils.getBookType();
    this.langs = this.langs.sort((a, b) => (a.order - b.order));
    sessionStorage.clear();
    this.subscription = this.messageService.getMessage().subscribe(
      message => {
        this.message = message;
      },
      err => { },
      () => { }
      );
    Utils.setLang(this.translate, sessionStorage.getItem('lang'), this.bookType);
  }

  selectionChanged(value) {
    // console.log(value);
    if (value !== undefined) {
      this.isLoadnig = false;
      sessionStorage.setItem('availableTrainings', JSON.stringify(this.ways[value - 1].trainingCodes));
    }
  }
  onClick() {
    this.router.navigate(['/trainingselect']);
  }
}
